<template>
  <div>
    <Form @find-button-triggered="resetZoomMap()" :postcode="postcode" :country-code="countryCode" :town="town" :authorizedNatures="authorizedNatures" :loadAndSearch="true"/>
    <ParcelshopList ref="parcelshopList" v-if="isSearchInitialized" :numeroUnavailableParcelshop="numeroUnavailableParcelshop" @parcelshop-selected="ascendEvent"  />
  </div>
</template>

<script>
import Form from "../Form/Form.vue";
import { mapState } from "vuex";
import ParcelshopList from "../ParcelshopList/ParcelshopList.vue";

export default {
  name: "parcelshop-picker",
  props: {
    postcode: {
      type: String,
      required: false,
    },
    town: {
      type: String,
      required: false,
    },
    countryCode: {
      type: String,
      required: false,
    },
    printInStore: {
      type: Boolean,
      required: false,
    },
    showFilterPrintInStore: {
      type: Boolean,
      required: false 
    },
    showFilterLocker: {
      type: Boolean,
      required: false 
    },
    isPrintInStoreHighlighted: {
      type: Boolean,
      required: false
    },
    isLockerHighlighted: {
      type: Boolean,
      required: false
    },
    authorizedNatures: {
      type: String,
      required: false,
    },
    selectionMode: {
      type: Boolean,
      required: false,
    },
    priceMode: {
      type: Boolean,
      required: false,
    },
    avoidSaturated: {
      type: Boolean,
      required: false,
    },
    parcelshopNatureAllowed: {
      type: String,
      required: false,
    },
    parcelshopAgenceAllowed: {
      type: String,
      required: false,
    },
    numeroUnavailableParcelshop :{
      type: Number,
      required: false
    },
    typeLivraisonFilter: {
      type: String,
      required: false
    }
  },
  components: {
    Form,
    ParcelshopList,
  },
  computed: {
    ...mapState(["isSearchInitialized"]),
    
  },
  methods : {
    ascendEvent: function (parselshop){
      this.$emit('parcelshop-selected', parselshop)
    },
    resetZoomMap(){
      if(this.$refs.parcelshopList != null && typeof this.$refs.parcelshopList != 'undefined'){
        this.$refs.parcelshopList.resetZoomMap();
      }
    }
  },
  mounted() {
    this.$store.commit("setIsCountryPrintInStore", this.printInStore);
    this.$store.commit("setShowFilterPrintInStore", this.showFilterPrintInStore);
    this.$store.commit("setShowFilterLocker", this.showFilterLocker);
    this.$store.commit("setIsPrintInStoreHighlighted", this.isPrintInStoreHighlighted);
    this.$store.commit("setIsLockerHighlighted", this.isLockerHighlighted);
    this.$store.commit("setSelectionMode", this.selectionMode);
    this.$store.commit("setPriceMode", this.priceMode);
    this.$store.commit("setSaturatedParams", this.avoidSaturated);
    this.$store.commit("setParcelshopNatureAllowed", this.parcelshopNatureAllowed);
    this.$store.commit("setParcelshopAgenceAllowed", this.parcelshopAgenceAllowed);
    this.$store.commit("setTypeLivraisonFilter", this.typeLivraisonFilter);
  },
};
</script>
